import React from 'react'

import {InitContext} from './components/init-context'
import {ObjectStore} from './components/object-store'
import {ResourcesModal} from './components/resource'
import SelectionShelf from './components/selection-shelf'
import {SelectionShelfContext} from './components/selection-shelf'
import {SpinningContext} from './components/spinning-context'
import LoginPage from './page-login'
import MapPage from './page-map'
import PageMultiAdd from './page-multi-add'
import ProducersPage from './page-producers'
import PageProductPreset from './page-product-preset'
import ProductsPage from './page-products'
import ProductsNotesPage from './page-products-notes'
import PageSavedQueries from './page-saved-queries'
import PageTemplates from './page-templates'
import PageTrash from './page-trash'
import useHash from './utils/use-hash'
import {RouterContext} from './utils/use-hash'
import PageProduct from './page-product'
import './app.scss'
import './sheets.scss'


const Router = React.memo(Router_)


export default function App() {
    return <RouterContext>
        <SpinningContext>
            <ObjectStore>
                <InitContext>
                    <SelectionShelfContext>
                        <Router />
                        <ResourcesModal />
                    </SelectionShelfContext>
                </InitContext>
            </ObjectStore>
        </SpinningContext>
    </RouterContext>
}

function Router_() {
    const {hash, setHash} = useHash()

    if (hash.startsWith('#login')) {
        return <LoginPage />
    }
    if (hash.startsWith('#products-notes')) {
        return <ProductsNotesPage hash={hash} setHash={setHash} />
    }
    if (hash.startsWith('#products')) {
        return <ProductsPage hash={hash} setHash={setHash} />
    }
    if (hash.startsWith('#product')) {
        return <PageProduct hash={hash} setHash={setHash} />
    }

    if (hash.startsWith('#producers')) {
        return <ProducersPage hash={hash} setHash={setHash} />
    }
    if (hash.startsWith('#templates')) {
        return <PageTemplates hash={hash} setHash={setHash} />
    }
    if (hash.startsWith('#queries')) {
        return <PageSavedQueries hash={hash} setHash={setHash} />
    }
    if (hash.startsWith('#trash')) {
        return <PageTrash hash={hash} setHash={setHash} />
    }
    if (hash.startsWith('#multiadd')) {
        return <PageMultiAdd hash={hash} setHash={setHash} />
    }
    if (hash.startsWith('#product-preset')) {
        return <PageProductPreset hash={hash} setHash={setHash} />
    }
    return <MapPage hash={hash} setHash={setHash} />
}
